var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[((_vm.page_type == 'requireAuth') || (_vm.page_type == 'onlyMain'))?_c('v-main',[_c('Layout2',{attrs:{"page_type":_vm.page_type}})],1):_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }